import React, { useEffect } from "react";
import DetailPage from "./DetailPage";
import { default as useApiHook } from "./assets/api/UseAxios";
const Temporary = () => {
  const path = window?.location.pathname;
  const encodedString = path.split("/").pop();
  console.log("Encoded:", encodedString);

  const {
    data: fetchedData,
    loading: apiLoading,
    fetchData,
  } = useApiHook<{
    data: any;
  }>({
    endpoint: `vehicle_maintenance/decode-defect-data/${encodedString}`,
    method: "GET",
  });
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (fetchedData) {
      //@ts-ignore
      const requiredData = fetchedData?.workshop_id;
      console.log("requiredData", requiredData);
    }
  }, [apiLoading]);
  return (
    <div>
      <DetailPage fetchedData={fetchedData} />
    </div>
  );
};

export default Temporary;
